let SERVER_URI
let URL_EXTENSION

if (process.env.NODE_ENV === 'production') {
  SERVER_URI = process.env.REACT_APP_API_URI
  URL_EXTENSION = '/'
} else {
  SERVER_URI = 'http://localhost:3000'
  URL_EXTENSION = '/'
}

export { SERVER_URI, URL_EXTENSION }

